import React from 'react';
import useSWR from 'swr';
import axios from 'axios';

const useUserData = (userId, lat, lon, city, host, name, addressName) => {
    const [userData, setUserData] = React.useState(null);

    const fetcher = (url) => axios.get(url, {
        params: {
            userID: userId,
            lat,
            lon,
            city,
            host,
            name,
            addressName
        }
    });


    const {
        data,
        error,
        mutate
    } = useSWR('https://idmarket-api.taximaxim.com/api/v1/name', fetcher); // prod
    // const {
    //     data,
    //     error,
    //     mutate
    // } = useSWR('http://localhost:8001/api/v1/name', fetcher); // dev

    React.useEffect(() => {
        if (data) {
            setUserData(data.data);
        }
        if (error) {
            setUserData(null);
        }

        console.log(data)
        // eslint-disable-next-line
    },[data, error]);

    return {
        userData,
        mutate,
        error
    }
}

export default useUserData;
